import { useEffect, useState } from 'react';
import { getCurrentSystem } from '@umu/ukit-lang';
import { getWxInfo } from '@umu/umu-api';
import { IWxInfoInput, IWxInfo } from '@umu/umu-api/src/services/wx/getWxInfo';

const SYSTEM = getCurrentSystem();

export const useWxFollowInfo = (param: IWxInfoInput) => {
    const [wxInfo, setWxinfo] = useState<IWxInfo>({
        scene_type: 0,
        is_follower: 1,
        scene_url: '',
    });

    useEffect(() => {
        if (SYSTEM === 'CN') {
            getWxInfo(param).then((res) => {
                if (!res.error_code) {
                    setWxinfo(res.data);
                }
            });
        }
    }, []);

    return wxInfo;
};
